var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIWatchBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 3,
    width: 28,
    height: 74,
    rx: 5.06667,
    fill: "url(#paint0_linear_343_10012)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 59.7402C51.0447 59.7402 59.999 50.7859 59.999 39.7402C59.999 28.6945 51.0447 19.7402 39.999 19.7402C28.9533 19.7402 19.999 28.6945 19.999 39.7402C19.999 50.7859 28.9533 59.7402 39.999 59.7402Z",
    fill: "#10141A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8848 48.2185L30.4751 41.3489L33.2877 46.6115L38.6579 34.5774L41.4569 43.0136L44.0498 37.8208L46.998 44.3051L54.6384 29.7383",
    stroke: "url(#paint1_radial_343_10012)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59.7657C51.0603 59.7657 60.0264 50.7996 60.0264 39.7393C60.0264 28.679 51.0603 19.7129 40 19.7129C28.9398 19.7129 19.9736 28.679 19.9736 39.7393C19.9736 50.7996 28.9398 59.7657 40 59.7657Z",
    stroke: "url(#paint2_linear_343_10012)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.7402C51.598 60.7402 61 51.3382 61 39.7402C61 28.1423 51.598 18.7402 40 18.7402C28.402 18.7402 19 28.1423 19 39.7402C19 51.3382 28.402 60.7402 40 60.7402Z",
    stroke: "url(#paint3_linear_343_10012)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_10012",
    x1: 40,
    y1: 3,
    x2: 40,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34383D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341346,
    stopColor: "#202428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#202428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34383D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_343_10012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1604 38.9784) rotate(129.56) scale(15.9225 25.8137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.370192,
    stopColor: "#3284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3284FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_10012",
    x1: 28,
    y1: 25.5,
    x2: 51.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50545A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62666C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_10012",
    x1: 26.5,
    y1: 23,
    x2: 51,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82868C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWatchBig);
export default __webpack_public_path__ + "static/media/i_watch_big.8c3be29977a277824930131904edd600.svg";
export { ForwardRef as ReactComponent };